import React from "react";

const PDFViewer = ({ url, width, height }) => {
  console.log("[PDFViewer] Rendering:", {
    url: url ? `${url.substring(0, 100)}...` : "(empty)",
    width,
    height,
    hasUrl: !!url,
  });

  if (!url) {
    console.warn("[PDFViewer] No URL provided, showing placeholder");
    return (
      <div style={{ width, height, backgroundColor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>No PDF URL available</p>
      </div>
    );
  }

  return (
    <iframe
      title="PDF Document Viewer"
      aria-label="PDF Viewer"
      src={`${url}`}
      style={{ width, height, border: "none" }}
      allowFullScreen
      onLoad={() => console.log("[PDFViewer] iframe loaded successfully")}
      onError={(e) => console.error("[PDFViewer] iframe error:", e)}
    >
      Your browser does not support PDFs. Please download the PDF to view it:{" "}
      <a href={url}>Download PDF</a>
    </iframe>
  );
};

PDFViewer.defaultProps = {
  width: "100%",
  height: "100vh",
};

export default PDFViewer;
